<template>
  <section class="pb-100" :style="`background-color: var(--${backgroundColor}) !important`">
    <div :class="variants.v1 === variant ? '' : 'page-padding'">
      <div class="container">
        <div class="tw-py-16">
          <!-- Industry Insights Header -->
          <div class="industry-insights-header tw-mb-16 tw-text-center">
            <div class="max-width-large tw-text-center">
              <h3 class="tw-mb-4">
                {{ vars.titleText }}
              </h3>
            </div>
          </div>

          <!-- Blog Cards Grid -->
          <div class="insights-grid tw-grid tw-grid-cols-1 tw-gap-8 md:tw-grid-cols-2 lg:!tw-grid-cols-3">
            <div v-for="(blog, index) in blogs" :key="`insight-${index}`" class="insight-card tw-col-span-1">
              <nuxt-link
                :to="blog.link"
                class="card-link n-link tw-block tw-h-full tw-transition-all tw-duration-300 hover:tw-transform"
                :external="true"
              >
                <div class="card-image-wrapper tw-relative tw-mb-4 tw-overflow-hidden" style="aspect-ratio: 480/320">
                  <library-image
  alt="blog photo"
  loading="lazy"
  :w-ratio="3"
  :h-ratio="2"
  :src="blog.photo"
  image-class="!tw-object-fill tw-w-full tw-h-full tw-transition-transform tw-duration-300"
  style="border-radius: var(--rounded)"
/>

                </div>

                <div class="card-content">
                  <div class="card-title tw-mb-3">
                    <h5 class="tw-line-clamp-2 tw-text-start tw-text-lg tw-font-bold tw-text-gray-900">
                      {{ blog.title }}
                    </h5>
                  </div>
                  <p class="tw-mb-4 tw-line-clamp-3 tw-text-start tw-text-sm tw-text-gray-600">
                    {{ blog.description }}
                  </p>

                  <!-- Green bottom line -->
                  <div class="bottom-line"></div>
                </div>
              </nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme2/base/NotFound.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme2ManualBlogsBox',
  components: { NcButton, NotFound, Loader },

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
      },
    };
  },

  computed: {
    backgroundColor() {
      return getVariable(this.component, 'background-color');
    },

    variant() {
      return useVariant(this.component);
    },

    blogs() {
      const blogs = this.groupedVariables.blogs;

      return blogs.map((blog) => {
        return {
          ...blog,
          url_in_use: blog.url && blog.url.includes('blogs') ? blog.url : `/blogs/${blog.url}`,
        };
      });
    },

    titleHtml() {
      return this.vars.titleHtml || 'Take a look at our latest blogs';
    },
  },
});
</script>

<style scoped>
/* Industry Insights Header */
.industry-insights-header {
  position: relative;
}

.insights-main-title {
  color: #1f2937;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Card Styles */
.insight-card {
  position: relative;
  transition: all 0.3s ease;
  height: 100%;
}

.insight-card:hover {
  transform: translateY(-5px);
}

.card-link {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-image-wrapper {
  background: #f8fafc;
  border-radius: 8px;
  overflow: hidden;
}

.cover-image {
  transition: transform 0.3s ease;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 16px;
}

.card-title h3 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.4;
}

.card-content p {
  flex: 1;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
}

/* Green bottom line */
.bottom-line {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #90c73d;
  border-radius: 1px;
}

/* Line clamp utilities */
.tw-line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tw-line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .insights-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .insights-grid {
    grid-template-columns: 1fr;
  }

  .insights-main-title {
    font-size: 2rem;
  }
}

@media (max-width: 640px) {
  .insights-main-title {
    font-size: 1.75rem;
  }
}
</style>
